import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useCookieConsent } from "@/context/CookieConsentContext";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";

// Turn plain text into nodes with clickable emails and URLs, preserving newlines.
const renderRich = (text) => {
  const parts = String(text || "").split(/(\s+)/);
  return parts.map((tok, i) => {
    const clean = tok.replace(/[.,;:]+$/, "");
    const trail = tok.slice(clean.length);
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(clean)) {
      return <span key={i}><a href={`mailto:${clean}`} className="text-[#0A3087] underline">{clean}</a>{trail}</span>;
    }
    if (/^(https?:\/\/|www\.)/i.test(clean)) {
      const href = clean.startsWith("http") ? clean : `https://${clean}`;
      return <span key={i}><a href={href} target="_blank" rel="noreferrer" className="text-[#0A3087] underline">{clean}</a>{trail}</span>;
    }
    return <span key={i}>{tok}</span>;
  });
};

export default function Privacybeleid() {
  const { openPreferences } = useCookieConsent();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/privacy").then((r) => setData(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="privacy-page">
      <PageHero
        eyebrow="Juridisch"
        title={<>Privacy-<br />verklaring.</>}
        subtitle="ELSA Brussel vzw hecht belang aan de bescherming van uw persoonsgegevens."
        testid="privacy-hero"
      />
      <section className="mx-auto max-w-[900px] px-6 lg:px-10 py-20">
        {data && (
          <>
            <Reveal>
              <p className="text-[#0B0B0C]/75 leading-relaxed mb-12 text-[15px]">{renderRich(data.intro)}</p>
            </Reveal>

            {data.sections?.map((s, i) => (
              <Reveal key={i}>
                <div className="mb-10">
                  <h2 className="font-serif text-2xl md:text-3xl text-[#0B0B0C] mb-3">{s.title}</h2>
                  <p className="text-[#0B0B0C]/75 leading-relaxed text-[15px] whitespace-pre-line">{renderRich(s.body)}</p>
                </div>
              </Reveal>
            ))}

            <Reveal>
              <div className="mt-4 mb-10">
                <button onClick={openPreferences} data-testid="privacy-cookie-settings" className="text-sm font-600 px-5 py-2.5 rounded-full text-white transition-transform hover:-translate-y-0.5" style={{ background: "var(--elsa-blue)" }}>
                  Cookievoorkeuren aanpassen
                </button>
              </div>
              <p className="text-sm text-[#0B0B0C]/40 pt-6 border-t border-black/10">Laatst bijgewerkt: {data.updated}</p>
            </Reveal>
          </>
        )}
      </section>
    </div>
  );
}
